import * as lib from "./lib/KMP-library-shared";

const engine = (lib as any).default.org.androidworks.engine as typeof lib.org.androidworks.engine;
const cemetery = (lib as any).default.org.androidworks.cemetery as typeof lib.org.androidworks.cemetery;

export { engine, cemetery, lib };
